/* oxlint-disable react/rules-of-hooks */
import * as React from 'react';
import { useSelector } from 'react-redux';

import { useActions } from '../useActions';

import { intOnly } from '../../utils/intOnly';

import { selectFormFields, selectIsNewbuilding } from '../../selectors';

import { IRoomNumberInputProps } from '../../../common/utils/types';
import { ECurrentErrorField } from '../../types/formFields';
import { EMyHomeEstimationTargets } from '../../types/estimationTarget';
import { trackMyHomeFlatNumberPick } from '../tracking';

export const useRoomNumberInputProps = (): IRoomNumberInputProps => {
  const { flatNumber, errorTooltip } = useSelector(selectFormFields);
  const { setFlatNumber } = useActions();
  const isNewbuilding = useSelector(selectIsNewbuilding);

  /** Если есть ошибка, отобразится над инпутом фильтра */
  const errorMessage = errorTooltip.currentErrorField === ECurrentErrorField.flatNumber ? errorTooltip.errorText : '';

  const onBlur = React.useCallback(() => {
    if (flatNumber) {
      trackMyHomeFlatNumberPick({
        estimationTarget: EMyHomeEstimationTargets.flat,
        value: flatNumber,
        auto: false,
        isNewbuilding,
      });
    }
  }, [flatNumber, isNewbuilding]);

  const onValueChange = React.useCallback<IRoomNumberInputProps['onValueChange']>(
    value => {
      const intVal = intOnly(value);

      setFlatNumber(Number(intVal));
    },
    [setFlatNumber],
  );

  return {
    value: flatNumber ? String(flatNumber) : '',
    errorMessage,
    onValueChange,
    onBlur,
  };
};
